import React, { useState, useRef } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList, Button as RaButton
} from 'react-admin';
import {
    useMediaQuery, makeStyles, Avatar, FormControl, InputLabel, Select, MenuItem, Dialog, DialogContent, DialogActions, Button
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import ParkingSearchSelector from "./components/ParkingSearchSelector";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomExportButton from './components/CustomExportButton';
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
import queryString from 'query-string';
import config from "./config.json";
import CustomFilter from './components/CustomFilter';
import { vehicleSvgs, hideName, hideVehicleNumber, hideMobileNumber as hideMobileMask } from "./sharedData";
import ScrollableTable from './components/ScrollableTable';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import RestoreIcon from "@material-ui/icons/Restore";
import UseAnalyticsEvent from './utils/useAnalyticsEvent';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
});



const renderVehicleType = row => (
    row.vehicle_type ?
        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 48 }} alt={row.vehicle_type_label} />
            {/* row.vehicle_type_label */}
        </div>
        :
        null
);

const CATEGORY = "PERMIT DELETE SECTION"

export const RfidsDeleteList = props => {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles();
    const location = useLocation();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const listDataRef = useRef();
    // const { permissions } = usePermissions();
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Vehicle Number", "RFID", "Name", "Mobile"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)

    let filterTypesInitState = [
        {
            filterType: "Vehicle",
            dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
    ]

    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};
    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const getExportFile = (fileType) => {
        const {current : {total, currentSort, filterValues}} = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/rfidsDeletedDetails?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `${currentParking && currentParking.name ? currentParking.name : "RFID Deleted Details"}.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    React.useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Vehicle") {
                    values = { ...values, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        eventTracker(CATEGORY, "PERMIT DELETE LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />
            }

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>

        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
            <CustomExportButton getCSV={getExcelFile} disabled={listDataRef.current && listDataRef.current.total === 0} />
        </div>
        <List
            {...props}
            style={{marginTop: 20}}
            title="RFID Deleted Details"
            bulkActionButtons={false}
            actions={false}
            exporter={false}
            filter={filter}
            empty={false}
            sort={{ field: 'deleted_on', order: 'DESC' }}
            pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}} />}
        >

            {isSmallDevice ?
                <SimpleList
                    leftIcon={row => row.vehicle_type ? <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ padding: 4, width: 28, height: 28, marginTop: 8, marginRight: 10 , overflow:"visible"}} /> : undefined}
                    primaryText={record => hideVehicleNumber(record.vehicle_number)}
                    secondaryText={record => (<div>
                        {record.rfid && <div><span style={{ color: "#5a5a5a" }}>RFID: </span>{record.rfid}</div>}
                        {record.username && <div><span style={{ color: "#5a5a5a" }}>Name: </span>{hideName(record.username)}</div>}
                        {record.mobile && <div><span style={{ color: "#5a5a5a" }}>Mob No: </span>{record.mobile.slice(0, -4)}****</div>}
                        {record.delete_by_name && <div><span style={{ color: "#5a5a5a" }}>Deleted By: </span>{record.delete_by_name}</div>}
                        {record.registration_date && <div><span style={{ color: "#5a5a5a" }}>Start Date: </span>{renderTime(record.registration_date)}</div>}
                        {record.deleted_on && <div><span style={{ color: "#5a5a5a" }}>Deleted On: </span>{renderTime(record.deleted_on)}</div>}
                        {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
            :
                <Datagrid className={ !viewOnly ? 'rfidApartmentsDataGrid' : ''} component={ScrollableTable}>
                    <FunctionField
                        source="vehicle_type"
                        label="Type"
                        render={record => record && renderVehicleType(record)}
                        sortable
                    />
                    <FunctionField source="vehicle_number" label="Vehicle Number" render={record => record && record["vehicle_number"] !== null ? hideVehicleNumber(record["vehicle_number"]) : "-"} />
                    <TextField source="rfid" label="RFID" />
                    <FunctionField source="username" label="Name" render={record => record && record["username"] !== null ? hideName(record["username"]) : ""} />
                    <FunctionField source="mobile" label="Mobile No." render={record => record && record["mobile"] !== null ? hideMobileMask(record["mobile"]) : ""} />
                    <FunctionField source="registration_date" label="Start Date" render={record => record && renderTime(record["registration_date"])} />
                    <TextField style={{ color: "#de575e" }} source="delete_by_name" label="Deleted By" />
                    <FunctionField style={{ color: "#de575e" }} source="deleted_on" label="Deleted On" render={record => record && renderTime(record["deleted_on"])} />
                    {/* <FunctionField source="scan_time" label="Scan Time" render={record => moment(record["scan_time"], "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY hh:mm:ss A")} /> */}
                    <TextField source='parking_name' label="Parking Name" />
                    {!viewOnly && <FunctionField className="ListIconsContainerRfidApartments" render={record => record &&
                        <div className="ListIcons" style={{ padding: "6px 15px" }}>
                           <RestoreButton {...props} record={record} />
                        </div>
                    } />}
                </Datagrid>
            }
        </List>
    </div>
};

function RestoreButton(props) {
    const { record } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));

    const [dialogVisible, setDialogVisible] = useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const restoreUser = (event) => {
        event.preventDefault();
        closeDialog();
        fetch(`${config.HOST_NAME}/crm/v3/deletedPermits/${record["id"]}/restore`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify("Permit Restored", "success");
                } else {
                    notify(json.message, "warning");
                }
            })
            .catch(error => {
                notify("Something went wrong", "warning");
                console.log(error);
            });
    };

    return (
        <div style={{ textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: isSmallDevice ? 0 : 1 }}>
            <RaButton title='Restore' disabled={props.disabled} label={false} color="secondary" onClick={openDialog}><RestoreIcon /></RaButton>

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
                <DialogContent>Are you sure you want to restore this Permit?</DialogContent>
                <DialogActions>
                    <Button color="default" onClick={closeDialog}>No</Button>
                    <Button color="secondary" onClick={restoreUser}>Yes</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}